import { isNotLast } from "@punks/core"
import classNames from "classnames"
import Link from "next/link"
import React from "react"
import classes from "./HeroBreadcrumb.module.css"
import { CustomContainer } from "../../spacings"
import Typography from "../../atoms/Typography"
import ExpandableText from "../../atoms/ExpandableText"

export interface BreadcrumbSegment {
  name: string
  url?: string
}

export interface HeroBreadcrumbProps {
  center?: boolean
  backgroundImage?: string
  backgroundImageMobile?: string
  title?: string
  subtitle?: React.ReactNode
  logo?: React.ReactNode
  className?: string
  segments: BreadcrumbSegment[]
  description?: React.ReactNode
  descriptionExpandable?: boolean
  disableBg?: boolean
}

const HeroBreadcrumb = ({
  title,
  className,
  segments,
  center,
  logo,
  subtitle,
  description,
  descriptionExpandable,
  disableBg,
}: HeroBreadcrumbProps) => {
  return (
    <div
      className={classNames(
        classes.root,
        {
          [classes.rootWithBg]: disableBg !== true,
          [classes.center]: center,
        },
        className
      )}
    >
      <CustomContainer>
        <div
          className={classNames(classes.segments, {
            [classes.segmentsCenter]: center,
          })}
        >
          {segments?.map((segment: BreadcrumbSegment, index: number) => (
            <div
              key={index}
              className={classNames(classes.segment, {
                [classes.segmentNotActive]: isNotLast(index, segments),
              })}
            >
              {segment.url ? (
                <Link href={segment.url} passHref>
                  <a>
                    <Typography
                      variant="body2"
                      textClassName={classes.segmentName}
                    >
                      {segment.name}
                    </Typography>
                  </a>
                </Link>
              ) : (
                segment.name
              )}
              {isNotLast(index, segments) && (
                <Typography variant="body2" textClassName={classes.separator}>
                  /
                </Typography>
              )}
            </div>
          ))}
        </div>
        {!logo && title && (
          <Typography textClassName={classes.title} variant="h3" component="p">
            {title}
          </Typography>
        )}
        {logo}
        {subtitle}
        {description && (
          <div className={classes.description}>
            <ExpandableText disabled={!descriptionExpandable}>
              {description}
            </ExpandableText>
          </div>
        )}
      </CustomContainer>
    </div>
  )
}

export default HeroBreadcrumb
